import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { DEFAULT_CONTENT } from "../data/content";

const SiteContext = createContext(DEFAULT_CONTENT);

const merge = (data) => {
  const out = { ...DEFAULT_CONTENT };
  Object.keys(DEFAULT_CONTENT).forEach((k) => {
    const v = data?.[k];
    if (v == null) return;
    const d = DEFAULT_CONTENT[k];
    if (Array.isArray(d)) out[k] = Array.isArray(v) ? v : d;
    else if (typeof d === "object") out[k] = typeof v === "object" && !Array.isArray(v) ? { ...d, ...v } : d;
    else out[k] = v;
  });
  return out;
};

export const withLinks = (c) => ({
  ...c,
  whatsappUrl: `https://wa.me/${c.contact.whatsapp_number}?text=${encodeURIComponent("Hello Bedsolving, I'd like to discuss my property.")}`,
  phoneHref: `tel:+${c.contact.whatsapp_number}`,
});

export const SiteProvider = ({ children }) => {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  useEffect(() => {
    let alive = true;
    api.get("/content").then((r) => { if (alive) setContent(merge(r.data)); }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return <SiteContext.Provider value={content}>{children}</SiteContext.Provider>;
};

export const useSite = () => withLinks(useContext(SiteContext));
